import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.marquee-cta__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          direction: 'ttb',
          pagination: false,
          autoHeight: true,
          drag: false,
          gap: '32px',
          arrows: false,
          height: '100%',
          autoScroll: {
            speed: .75,
            pauseOnFocus: false,
            pauseOnHover: false,
          },
        } ).mount( {AutoScroll} );
      } );

      $( '.marquee-cta-mobile__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          pagination: false,
          autoWidth: true,
          drag: false,
          gap: '12px',
          arrows: false,
          autoScroll: {
            speed: .75,
            pauseOnFocus: false,
            pauseOnHover: false,
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee-cta', COMPONENT );
} )( app );
